import { Link } from "react-router-dom";

const CONTACT = process.env.REACT_APP_CONTACT_EMAIL || "hello@barrettcareerbrand.com.au";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LEGAL = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Service" },
  { to: "/refunds", label: "Refund & Cancellation" },
  { to: "/data-handling", label: "CV Data Handling & AI" },
  { to: "/contact", label: "Contact" },
];

const CLIENT_PROTECTION_LINK = { href: "/#client-protection", label: "Client Protection Pack" };
export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-[#27272A] bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <span className="font-display text-lg font-bold tracking-tighter text-[#F8F8F5]">
            Barrett Career <span className="text-[#DFFF00]">Brand</span>
          </span>
          <p className="mt-4 font-body text-sm text-[#52525B] leading-relaxed max-w-xs">
            Strategic professional positioning across CV and LinkedIn for professionals across Australia.
          </p>
          <a href={`mailto:${CONTACT}`} className="mt-4 inline-block font-body text-sm text-[#A1A1AA] hover:text-[#DFFF00] transition-colors">
            {CONTACT}
          </a>
        </div>

        <div>
          <p className="tracking-label text-[10px] uppercase font-body font-bold text-[#52525B] mb-4">Legal</p>
          <ul className="space-y-2">
            {LEGAL.map((l) => (
              <li key={l.to}>
                <Link data-testid={`footer-${l.to.slice(1)}`} to={l.to} className="font-body text-sm text-[#A1A1AA] hover:text-[#DFFF00] transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <a
                data-testid="footer-client-protection"
                href={`${API}/client-protection/pack`}
                target="_blank"
                rel="noopener noreferrer"
                className="font-body text-sm text-[#A1A1AA] hover:text-[#DFFF00] transition-colors"
              >
                {CLIENT_PROTECTION_LINK.label}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="tracking-label text-[10px] uppercase font-body font-bold text-[#52525B] mb-4">Explore</p>
          <ul className="space-y-2">
            <li><Link data-testid="footer-services" to="/services" className="font-body text-sm text-[#A1A1AA] hover:text-[#DFFF00] transition-colors">Services & Pricing</Link></li>
            <li><Link data-testid="footer-career-strategy" to="/services" className="font-body text-sm text-[#A1A1AA] hover:text-[#DFFF00] transition-colors">Career Strategy, CV and LinkedIn</Link></li>
            <li><Link data-testid="footer-small-business" to="/services" className="font-body text-sm text-[#A1A1AA] hover:text-[#DFFF00] transition-colors">Small Business and Self Employment</Link></li>
            <li><Link data-testid="footer-insights" to="/insights" className="font-body text-sm text-[#A1A1AA] hover:text-[#DFFF00] transition-colors">Insights</Link></li>
            <li><Link to="/linkedin" className="font-body text-sm text-[#A1A1AA] hover:text-[#DFFF00] transition-colors">For LinkedIn visitors</Link></li>
            <li><a href="/#consultation" className="font-body text-sm text-[#A1A1AA] hover:text-[#DFFF00] transition-colors">Free positioning consultation</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#27272A]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6">
          <p className="font-body text-xs text-[#52525B]">© {new Date().getFullYear()} Barrett Career Brand. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
